import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AbstractList from "./pages/AbstractList";
import SessionDetail from "./pages/SessionDetail";
import CaseInformation from "./pages/CaseInformation";

const CURRENT_YEAR = "2026"; // 年が変わったらここだけ更新

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={`/${CURRENT_YEAR}`} replace />} />
        <Route path="/:year" element={<AbstractList />} />
        <Route path="/:year/session/:id" element={<SessionDetail />} />
        <Route path="/:year/case/:caseid" element={<CaseInformation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;